import React from 'react';
import BANNER_FULL_MOBILE_Covid_01_Nasal from '../../Assets/BANNER-FULL-MOBILE_Covid_01_Nasal.png';
import BANNER_FULL_MOBILE_Covid_01_Oral from '../../Assets/BANNER-FULL-MOBILE_Covid_01_Oral.png';
import BANNER_FULL_MOBILE_Covid_01_Sanguineo from '../../Assets/BANNER-FULL-MOBILE_Covid_01_Sanguineo.png';
import BANNER_FULL_Covid_01_Saliva from '../../Assets/BANNER-FULL_Covid_01_Saliva.png';
import BANNER_FULL_Covid_02_Nasal from '../../Assets/BANNER-FULL_Covid_02_Nasal.png';
import BANNER_FULL_Covid_03_Sanguineo from '../../Assets/BANNER-FULL_Covid_03_Sanguineo.png';
import TesteCovidMobile from '../../Assets/mobile_teste-covid.png';
import TesteCovid from '../../Assets/teste-covid.png';
import './carousel.scss';

var slideIndex = 1;

function plusSlides(n) {
    showSlides(slideIndex += n);
}

function currentSlide(n) {
    showSlides(slideIndex = n);
}

function showSlides(n) {
  var i;
  var slides = document.getElementsByClassName("mySlides");
  var dots = document.getElementsByClassName("dot");
  if (n > slides.length) {slideIndex = 1}    
  if (n < 1) {slideIndex = slides.length}
  for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";  
  }
  for (i = 0; i < dots.length; i++) {
      dots[i].className = dots[i].className.replace(" active", "");
  }
  
  if(slides.length > 0){
    slides[slideIndex-1].style.display = "block";  
  }
  if(dots.length > 0){
    dots[slideIndex-1].className += " active";
  }
}

class Carousel extends React.PureComponent {

    componentDidMount(){
        showSlides(slideIndex);
    }

    render(){
        const { onBannerClick } = this.props

        return( 
            <>
                <div className="slideshow-container fadeIn">

                    <div style={{cursor:'pointer'}} className="mySlides fade" onClick={ onBannerClick }>
                        <div className="numbertext">1 / 4</div>
                        <img className="display" src={ TesteCovid } style={{width:"100%"}}/>
                        <img className="display-mobile" src={ TesteCovidMobile } style={{width:"100%"}} />                      
                    </div>

                    <div style={{cursor:'pointer'}} className="mySlides fade" onClick={ onBannerClick }>
                        <div className="numbertext">2 / 4</div>
                        <img className="display" src={ BANNER_FULL_Covid_01_Saliva } style={{width:"100%"}}/>
                        <img className="display-mobile" src={ BANNER_FULL_MOBILE_Covid_01_Nasal } style={{width:"100%"}} />                      
                    </div>

                    <div style={{cursor:'pointer'}} className="mySlides fade" onClick={ onBannerClick }>
                        <div className="numbertext">3 / 4</div>
                        <img className="display" src={ BANNER_FULL_Covid_02_Nasal } style={{width:"100%"}}/>
                        <img className="display-mobile" src={ BANNER_FULL_MOBILE_Covid_01_Oral } style={{width:"100%"}} />                      
                    </div>

                    <div style={{cursor:'pointer'}} className="mySlides fade" onClick={ onBannerClick }>
                        <div className="numbertext">4 / 4</div>
                        <img className="display" src={ BANNER_FULL_Covid_03_Sanguineo } style={{width:"100%"}}/>
                        <img className="display-mobile" src={ BANNER_FULL_MOBILE_Covid_01_Sanguineo } style={{width:"100%"}} />                      
                    </div>

                    <a className="prev" onClick={()=>plusSlides(-1)} >&#10094;</a>
                    <a className="next" id="next" onClick={()=>plusSlides(1)}>&#10095;</a>

                </div>
                <br/>
                <div style={{textAlign:"center"}}>
                    <span className="dot" onClick={()=>currentSlide(1)}></span> 
                    <span className="dot" onClick={()=>currentSlide(2)}></span> 
                    <span className="dot" onClick={()=>currentSlide(3)}></span> 
                    <span className="dot" onClick={()=>currentSlide(4)}></span>
                </div>
            </>
        )
    }
        
}

export default Carousel